import { render } from "./productionPhase.vue?vue&type=template&id=39204f4f&ts=true"
import script from "./productionPhase.vue?vue&type=script&lang=ts"
export * from "./productionPhase.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__